/** Space between the elements in the modal. Last elements of the modal shouldn't have the padding */
export const SPACE_ELEMENTS_OF_MODAL = "24px";

/** Custom styling for errors in stack components */
export const STACK_ERROR_SX = {
  marginBottom: SPACE_ELEMENTS_OF_MODAL,
  "& .Mui-error": {
    marginLeft: "2px"
  }
};